import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import BuscarEmpleado from '../BuscarEmpleado';
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ConfigurarEnvioReporte(props) {
    const { regional, setVentana } = props;
    const [personas, setPersonas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [horas, setHoras] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24])
    const [hora, setHora] = useState(3);
    const setColaborador = (colaborador) => {
        fetch(`${server}/reporte/agregarUsuarioSendReporte`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, idEmpleado: colaborador.ID_EMPLEADO, campo: "ENVIO_CORREO_REPORTE_MOTO"
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setPersonas([...personas, colaborador])
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(error => MsgUtils.msgError(error))
    }
    function eliminarDlista(datos) {
        fetch(`${server}/reporte/eliminarUsuarioSendReporte`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, idEmpleado: datos.ID_EMPLEADO, campo: "ENVIO_CORREO_REPORTE_MOTO"
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    var aux = personas.filter((item) => item.ID_EMPLEADO != datos.ID_EMPLEADO);
                    setPersonas(aux);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(error => MsgUtils.msgError(error))
    }
    function guardarHoraSend(valor) {
        fetch(`${server}/reporte/setHoraEnvioReporteMoto`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional,'hora':parseInt(valor)
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setHora(parseInt(valor));
                    MsgUtils.msgCorrecto(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(error => MsgUtils.msgError(error))
    }
    useEffect(() => {
        if (personas.length == 0) {
            
            fetch(`${server}/reporte/getHoraEnvioReporteMoto`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        if(data.ok.length!=0){
                            setHora(parseInt(data.ok[0].DATO_FLOAT));
                        }
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(error => MsgUtils.msgError(error))
            fetch(`${server}/reporte/getUsuariosSendReporte`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setPersonas(data.ok);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(error => MsgUtils.msgError(error))
        }
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <button className='btn btn-danger btn-sm' onClick={() => setVentana(0)}><i className="fa-solid fa-circle-left"></i> Atras</button>
                <button className='btn btn-success btn-sm mx-2' onClick={() => setShowModal(true)}><i className="fa-solid fa-person"></i> Agregar</button>
            </div>
            <div className='container-fluid bg-secondary bg-gradient'>
                <div className="py-2" style={{ width: '200px' }}>
                    <label className="form-label text-light fw-bold">Hora Para Hacer el envio ?</label>
                    <select className="form-select" aria-label="Default select example" value={hora} onChange={(e) => guardarHoraSend(e.target.value)}>
                        {horas.map((item, index) => {
                            return (<option value={parseInt(item)} key={index}>{item}</option>)
                        })}
                    </select>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-dark table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Colaborador a enviar</th>
                            <th scope="col">Correo</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {personas.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <th scope="row">
                                        <div className='container-fluid'>
                                            <div>{item.NOMBREX}</div>
                                            <div>{item.CARGO}</div>
                                        </div>
                                    </th>
                                    <td className='my-auto'>{item.EMAIL !== null ? item.EMAIL : <span className='badge  bg-danger'>"No tiene Correo Asociado"</span>}</td>
                                    <td className='my-auto'>
                                        <div className='btn-group'>
                                            <button className='btn btn-sm btn-danger' onClick={() => eliminarDlista(item)}><i className="fa-solid fa-trash-can"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                contentClassName='bg-dark bg-gradient text-light'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    Buscar Colaborador
                </Modal.Header>
                <Modal.Body>
                    <BuscarEmpleado setShowModal1={setShowModal} setColaborador={setColaborador} reg={regional} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ConfigurarEnvioReporte